export const featuredWalletsIds = [
    'metamask',
    'argent',
    'rainbow',
    'bitkeep',
    'okx-wallet',
]

export const HIDDEN_WALLETCONNECT_ID = 'hiddenWalletConnect'